<h1>Soporte Técnico</h1>
<div class="mt-8 card text-center">
   <div class="text-4xl">
      <a href="mailto:servicioestafetas@transnegrd.com"><span class="font-bold"><fa-icon icon="envelope"></fa-icon> servicioestafetas</span>@​transnegrd.com</a>
   </div>
   <!-- <div class="text-xl text-gray-500">correo electrónico</div> -->
   <div class="mt-4">Soporte técnico via correo electrónico disponible 24 horas</div>
</div>